module.exports = __webpack_public_path__ + "img/baby-girl.5e4b9149.svg";